<script setup lang="ts">
definePageMeta({
  layout: 'blank',
});

const { isAuthenticated } = storeToRefs(useAuthStore());
const { modalType } = storeToRefs(useLayoutStore());
const { closeModal } = useLayoutStore();

const closeModalOrGoToHome = () => {
  if (window.self !== window.top) {
    closeModal();
    window.parent.postMessage('closeModal');

    return;
  }

  navigateTo(localeLink('/'));
};

watchEffect(() => {
  if (isAuthenticated.value) {
    nextTick(() => {
      closeModalOrGoToHome();
    });
  }
});

onMounted(() => {
  modalType.value = 'forgot-password';
  window.parent.postMessage('iframeReady');
});
</script>

<template>
  <AuthPageLayout @action-to-close="closeModalOrGoToHome">
    <AuthForgotPassword />
  </AuthPageLayout>
</template>
